import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase";

export default ProtectedRoute => {
  const configs = {
    apiBase: "js/resources/assets.json",
    imagePath: "assets/ivPhotos/",
    // appUrl: "https://127.0.0.1/",
    appUrl: "https://api.lushplans.com/",
    webUrlBase: "https://lushplans.com/app/"
  };

  // Initialize Firebase
  var fireBaseConfig = {
    apiKey: "AIzaSyA1uztcHdiP2PX3pg7xf3ACAzkcFRdOM_M",
    authDomain: "la5sahapala1nasa.firebaseapp.com",
    databaseURL: "https://la5sahapala1nasa.firebaseio.com",
    projectId: "la5sahapala1nasa",
    storageBucket: "la5sahapala1nasa.appspot.com",
    messagingSenderId: "240974799011"
  };
  if (firebase.apps.length < 1) {
    firebase.initializeApp(fireBaseConfig);
  }

  const lpKey = "lushplans-user-key_couples";
  const tokenExpiry = 0;
  // Configure FirebaseUI.
  const uiConfig = {
    signInFlow: "popup",
    signInSuccessUrl: "/signedIn",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.PhoneAuthProvider.PROVIDER_ID
    ],
    tosUrl: "https://lushplans.com/app/terms.html",
    callbacks: {
      signInSuccess: function(currentUser, credential, redirectUrl) {
        console.log(currentUser);
        console.log(credential);
        console.log(redirectUrl);
        currentUser = JSON.parse(JSON.stringify(currentUser));
        console.log(currentUser);
        currentUser.lushPlanToken = currentUser.refreshToken
          ? currentUser.refreshToken + "{!EXTERNALAUTH!}"
          : currentUser.stsTokenManager.refreshToken + "{!EXTERNALAUTH!}";
        var expiry = new Date();
        currentUser.exp = expiry.getDate() + tokenExpiry;
        currentUser.username = currentUser.phoneNumber || currentUser.email;
        currentUser._id =
          currentUser.providerData[0].providerId +
          "***ID***" +
          currentUser.providerData[0].uid;

        const url =
          configs.appUrl +
          "_social_signin/?token=" +
          currentUser.lushPlanToken +
          "&_id=" +
          currentUser._id;
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw Error("Network request failed");
            }
            return response;
          })
          .then(d => d.json())
          .then(
            d => {
              console.log(d);
              if (d.user) {
                // >> Get Wedding
                const url =
                  configs.appUrl +
                  "_wedding/?token=" +
                  currentUser.lushPlanToken +
                  "&_id=" +
                  currentUser._id;
                fetch(url)
                  .then(response => {
                    if (!response.ok) {
                      throw Error("Network request failed");
                    }
                    return response;
                  })
                  .then(d => d.json())
                  .then(
                    d => {
                      currentUser.wedding = d;
                      currentUser.weddingId = d._id;
                      localStorage.setItem(lpKey, JSON.stringify(currentUser));
                      window.location.reload();
                    },
                    () => {
                      //   Error
                    }
                  );
                // >> End Get Wedding
              } else {
                //  bad block
              }
            },
            () => {
              //   Error
            }
          );

        return false;
      },
      signInFailure: function(error) {
        console.log(error);
        // return handleUIError(error)
      },
      uiShown: function() {
        // The widget is rendered.
        // Hide the loader.
        // document.getElementById('loader').style.display = 'none';
      }
    }
  };

  class AuthHOC extends Component {
    // eslint-disable-next-line
    constructor(props, context) {
      super(props, context);
      this.state = {
        wedding: {}
      };
    }

    // Check if there is validated user logged
    isLoggedin = () => {
      const currentTime = new Date().getDate();
      const info = this.userInfo();
      if (!currentTime || currentTime > info.exp) {
        return false;
      }
      return info;
    };

    // Check if the Authorization query is loading
    isLoading = () => {
      return this.props.Authorization.loading;
    };

    logOut = () => {
      localStorage.removeItem(lpKey);
    };

    userInfo = () => {
      const data = localStorage.getItem(lpKey);
      if (!data) {
        return false;
      }
      const user = JSON.parse(data);
      return user ? user : false;
    };

    render() {
      // Pass the received 'props' and created functions to the ProtectedRoute component
      return (
        <div>
          <ProtectedRoute
            {...this.props}
            isLoggedin={this.isLoggedin}
            isLoading={this.isLoading}
            userInfo={this.userInfo}
            authPage={
              <div className="center-block">
                <p className="text-center"> Please sign in: </p>
                <StyledFirebaseAuth
                  uiConfig={uiConfig}
                  firebaseAuth={firebase.auth()}
                />
              </div>
            }
          />
        </div>
      );
    }
  }

  AuthHOC.contextTypes = {
    router: PropTypes.object.isRequired
  };

  return withRouter(AuthHOC);
};



// WEBPACK FOOTER //
// ./src/Components/Authenticator/Authenticator.js